// export const environment = {
//     production: false,
//     api_url: 'http://172.29.112.1:5000/api',
//     app_token: 'zHeRDGkDTgmNdD65BqSIYag0a3tezfUasd8rra7AJQ3FLf38tm1Auu732PK1NYYg',
//     pusher: {
//         key: '33df1cdd29d26a7fe961',
//         cluster: 'us2',
//     },
//     firebase: {
//         apiKey: 'AIzaSyCJqShwpjNjQy9zXV_qGIHFFX4AWj9xWEU',
//         authDomain: 'advc-baa72.firebaseapp.com',
//         projectId: 'advc-baa72',
//         storageBucket: 'advc-baa72.appspot.com',
//         messagingSenderId: '858627872207',
//         appId: '1:858627872207:web:70559280bc3dc967682eba'
//     }
// };

export const environment = {
    production: true,
    api_url: 'https://api.advantagecomplete.ca/api',
    app_token: 'zHeRDGkDTgmNdD65BqSIYag0a3tezfUasd8rra7AJQ3FLf38tm1Auu732PK1NYYg',
    pusher: {
        key: '33df1cdd29d26a7fe961',
        cluster: 'us2',
    },
    firebase: {
        apiKey: "AIzaSyAId5t7Bs5Y36GRtH6ZEhD5I3sYD88wxHk",
        authDomain: "advantage-connect-prod2.firebaseapp.com",
        projectId: "advantage-connect-prod2",
        storageBucket: "advantage-connect-prod2.firebasestorage.app",
        messagingSenderId: "8312002004",
        appId: "1:8312002004:web:2021ab50cae2a555c7f241",
        measurementId: "G-RMKFPHQTYR"
    }
};